import { format } from "date-fns";
import type { RentalListItem } from "../../domain/rental";
import { parseBackendTimestamp } from "./backend-dates";

// RentalListItem types these as string | undefined, but the API sends null for a
// missing value (every in-progress rental's endTime).
type ExportRental = Omit<RentalListItem, "startTime" | "endTime"> & {
  startTime?: string | null;
  endTime?: string | null;
};

// Browser-local to match the rentals list; the ISO-like layout keeps the column
// sortable and to-the-second in spreadsheets.
const toLocalTime = (value: string) =>
  format(parseBackendTimestamp(value), "yyyy-MM-dd HH:mm:ss");

export function toRentalExportRows(rentals: ExportRental[]): ExportRental[] {
  return rentals.map((rental) => {
    if (!rental.startTime) {
      throw new Error(`Rental ${rental.id} has no startTime`);
    }
    return {
      ...rental,
      startTime: toLocalTime(rental.startTime),
      endTime: rental.endTime ? toLocalTime(rental.endTime) : rental.endTime,
    };
  });
}
